module.exports = __webpack_public_path__ + "img/serverules.526547b2.png";